import { ReactElement } from 'react';
import FormGroup from '~/components/form/FormGroup';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldInput from '~/components/zod/ZodFieldInput';
import { BreOrderContext } from '~/tenants/bre/model/BreOrderContext';
import { BreOrderType } from '~/tenants/bre/model/enums';
import BreCopyrightDisclosure from '~/tenants/bre/performable/BreCopyrightDisclosure';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { PersonaType } from '~/tenants/common/TenantPersona';
import ZodFieldCheckbox from '~/components/zod/ZodFieldCheckbox';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import BreCinematicAddOns from '~/tenants/bre/performable/cinematic/BreCinematicAddOns';

export default function BreCinematicForm(props: TenantPerformableFormProps<BreOrderContext>): ReactElement {
  const { context, persona } = props;

  return (
    <FormGroup>
      {persona === PersonaType.OFFICE && (
        <>
          <FormHorizontal label="Self Edited">
            <ZodFieldCheckbox name="self_edited" />
          </FormHorizontal>
          <FormHorizontal label="Photo Editing Credits">
            <ZodFieldInput name="editing_credits" type="number" />
          </FormHorizontal>
        </>
      )}

      {context.metadata.type === BreOrderType.COMMERCIAL && (
        <FormHorizontal name="duration" label="Duration (mins)">
          <ZodFieldInput name="duration" type="number" />
        </FormHorizontal>
      )}

      <TenantPerformableAddOns persona={persona}>
        {/*<TenantPackageAddOnCheckboxName*/}
        {/*  name="rush"*/}
        {/*  title="Rush"*/}
        {/*  description="Need your video by the next business day instead of the second business day?"*/}
        {/*  image="tenant/bre/rush.jpg"*/}
        {/*  persona={persona}*/}
        {/*  cost={RUSH}*/}
        {/*/>*/}
        <BreCinematicAddOns context={context} persona={persona} />
      </TenantPerformableAddOns>

      {context.metadata.type === BreOrderType.RENTAL && <BreCopyrightDisclosure context={context} />}
    </FormGroup>
  );
}
